export const data = {
                        name: "TEAM UXTECH",
                        email: "uxtech@uxtech.ng",
                        password: "admin"
                    }